export default [
  {
    path: '/employee-performance-overview',
    name: 'employee-performance-overview',
    component: () => import('@/views/employeePerformanceOverview/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.employeePerformanceOverview',
      navActiveLink: 'employee-performance-overview',
      resource: 'employee-performance',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.employeePerformanceOverview',
          active: true,
        },
      ],
    },
  },
]
